import { RouterModule, Routes } from '@angular/router';

let routes: Routes = [
  {
    path: '',
    loadChildren: () => import('../pages/bursa-nivel-3/bursa-nivel-3.module').then((m) => m.BursaNivel3Module),
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '/',
    pathMatch: 'full',
  },
];

export const AppRouting = RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking'
});
